import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Row, Col, FormGroup, Input, Label, Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import CustomDatePicker from "../../comum/components/CustomDatePicker";
import NumberFormat from "react-number-format";
import { MonthPicker } from "../../comum/components/MonthPicker";
import { Validacao } from "../../comum/components/Validacao";
import PropTypes from "prop-types";
import Select from "react-select";
import qs from "query-string";
import _ from "lodash";
import CalculoCustoMotFiltroStore from "../stores/CalculoCustoMotFiltroStore";

//RHFPP-1548 - Consulta Custo Mot
@inject("store")
@observer
export class CalculoCustoMotFiltro extends Component {
    static propTypes = {
        history: PropTypes.object,
        location: PropTypes.object,
        onSubmit: PropTypes.func.isRequired,
        inicialDataValue: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.controller = new CalculoCustoMotFiltroStore();
        this.validacaoStore = this.props.store.validacaoStore;
    }

    componentDidMount() { // OK
        const params = qs.parse(this.props.location.search);

        this.controller.carregarListas(params, this.props.fields);

        if (_.isEmpty(params)) {
            //this.controller.setAnoCorrente(this.props.fields);
        } else {
            this.props.onSubmit(this.controller.getFiltro());
        }
    }

    onSubmit = (event) => { //OK
        event.preventDefault();
        event.stopPropagation();

        if (!this.canSubmit()) {
            return;
        }

        /*
        if (this.props.history && this.props.location) {
            
            this.props.history.push({
                pathname: this.props.location.pathname,
                search: qs.stringify(_.pickBy(this.controller.filtro, _.identity))
            });
        }
        */
        this.props.onSubmit(this.controller.getFiltro());
    }

    onClear = () => { //OK
        this.controller.limparFiltro(this.props.fields);
        if (this.props.controller) {
            this.props.controller.dadosCalculo = null;
            this.props.controller.dadosValidacao = null;
            this.props.controller.erro = null;
            this.props.store.formStore.setSubmitted(false);
            this.props.store.formStore.setSubmitMensagemErro("");
        }
        this.forceUpdate();
    }

    canSubmit = () => { //OK
        this.props.store.formStore.setSubmitted(true);
        this.props.store.formStore.setSubmitMensagemErro("");

        return this.props.store.validacaoStore.isValidForm;
    }

    render() {
        return (
            <div className="filter-container">
                <form onSubmit={(event) => this.onSubmit(event)} className="filter-box">
                    {<Col>
                            <Row>
                                <Col xs={12} md={6} lg={4}>
                                    <FormGroup>
                                        <Label for="lotacoes">Lotações ativas</Label>
                                        <Select id="lotacoes"
                                            value={this.controller.filtro.lotacaoId}
                                            onChange={(value) => this.controller.setLotacao(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Selecione a lotação"
                                            multi={false}
                                            options={[...this.controller.lotacoes]} />
                                        {<Validacao id="lotacoesObrigatorias" valor={this.controller.lotacoesValidacao}
                                            tipo={["isRequired"]} />
                                        }
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={6} lg={4}>
                                    <FormGroup>
                                        <Label for="cargos">Cargo</Label>
                                        <Select id="cargos"
                                            value={this.controller.filtro.cargoId}
                                            onChange={(value) => this.controller.setCargo(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Selecione um cargo para calcular o orçamento"
                                            multi={false}
                                            options={[...this.controller.cargos]} />
                                        {<Validacao id="cargosObrigatorios" valor={this.controller.cargosValidacao}
                                            tipo={["isRequired"]} />
                                        }
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={6} lg={3}>
                                    <FormGroup>
                                        <Label for="valorProposto">Valor proposto de salário</Label>
                                        <NumberFormat id="valorProposto"
                                            allowNegative={false}
                                            className="form-control"
                                            thousandSeparator="."
                                            decimalPrecision={2}
                                            decimalSeparator=","
                                            prefix={'R$ '}
                                            value={this.controller.filtro.valorProposto}
                                            onChange={(event, values) => this.controller.setValorProposto(values.floatValue)}
                                        />
                                        {<Validacao id="valorProposto" valor={this.controller.valorPropostoValidacao}
                                            tipo={["isRequired"]} />}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    {this.props.onSubmit &&
                                        <Button color="primary" type="submit">Calcular</Button>
                                    }
                                    {" "}
                                    {" "}
                                    <Button onClick={() => this.onClear()}>Limpar</Button>
                                </Col>
                            </Row>
                        </Col>
                    }
                </form>
            </div>
        );
    }
}
